<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="canEdit"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <action-toolbar-search name="filterSearch" [(ngModel)]="grid.filter"></action-toolbar-search>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid id="mainGrid" #mainGrid appAutoSize (initialized)="grid.initialize(mainGrid)" (destroy)="grid.destroy()" [itemsSource]="grid.view">
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="'*'" [dataMap]="equipmentDataMap">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'equipment', equipment: cell.item.equipment }">{{
                        parent.equipmentDisplay(cell.item.equipment)
                    }}</a>
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Filter Type'" [binding]="'filterType'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Qty'" [binding]="'quantity'" [width]="60"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'OEM'" [binding]="'oemPartNumber'" [width]="'*'">
                <ng-template wjFlexGridCellTemplate cellType="Cell" let-cell="cell">
                    @if (cell.item.oemPartNumber) {
                        <a [routerLink]="['/equipment/parts-fluids-lookup']" [queryParams]="{ tab: 'item', item: cell.item.oemPartNumber }">{{
                            cell.item.oemPartNumber
                        }}</a>
                    }
                </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Baldwin'" [binding]="'baldwinPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Fleetguard'" [binding]="'fleetguardPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'NAPA'" [binding]="'napaPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Advance Auto'" [binding]="'advanceAutoPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Wheeler'" [binding]="'wheelerPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Donaldson'" [binding]="'donaldsonPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Wix'" [binding]="'wixPartNumber'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Kenworth'" [binding]="'kenworthPartNumber'" [width]="'*'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
